import { Injectable } from '@angular/core';
import { Permissions } from './permissions.model';

@Injectable()
export class PermissionsService {

  constructor() { }

  public getUserPermissions(claimType: string): Permissions {
    let token = localStorage.getItem("token");
    let permissions = new Permissions(false, false, false, false, false, false, false, false, false, false, false, null);
    if (!token)
      return permissions;

    let payload = JSON.parse(atob(token.split('.')[1]));
    permissions.canAdd = payload[`Add${claimType}`] === 'True';
    permissions.canDelete = payload[`Delete${claimType}`] === 'True';
    permissions.canEdit = payload[`Edit${claimType}`] === 'True';
    permissions.canShow = payload[`Show${claimType}`] === 'True';
    permissions.hasBudgetPermission = payload['HasBudgetPermission'] === 'True';
    permissions.hasAllWorklogsPermission = payload['HasAllWorklogsPermission'] === 'True';
    permissions.hasIssuesNotAssignedPermission = payload['HasIssuesNotAssignedPermission'] === 'True';
    permissions.hasIsToTfsPermission = payload['HasIsToTfsPermission'] === 'True';
    permissions.hasCustomerBlockingPermission = payload['HasCustomerBlockingPermission'] === 'True';
    permissions.hasExtIssuesRcpReportPermission = payload['HasExtIssuesRcpReportPermission'] === 'True';
    permissions.hasExtIssuesRcpReportForeignPayerPermission = payload['HasExtIssuesRcpReportForeignPayerPermission'] === 'True';

    permissions.customerId = payload['CustomerId'];

    return permissions;
  }
}
